import gql from 'graphql-tag';

export const VENDOR_BRANCH_FIELDS = gql`
  fragment VendorFields on OdProtosVendorsData_VendorBranch {
    id
    fenceId
    name
    status
    capabilities {
      capabilityType
      configuration {
        ... on OdProtosVendorsData_Capability_ConfigurationOneof_D1WConfiguration {
          d1wConfiguration {
            maxD1wsPerDay
            maxD1wsPerWeek
          }
        }
      }
    }
    organization {
      email
      primaryPhone
    }
    vendor {
      id
      name
      createdAt
      branchIds
      compliance {
        complianceStatus
        workersCompExpires
        workersCompExempt
        autoInsuranceExpires
        generalLiabilityInsuranceExpires
      }
    }
  }
`;
